import { mapTo } from 'rxjs/operators';

export const toUndefined = mapTo(undefined);
